<template>
  <el-select v-model="v" filterable default-first-option remote placeholder="搜索平台" :size="size"
             clearable>
    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"/>
  </el-select>
</template>

<script>
import {getOptionListByField} from "@/api/option";

export default {
  name: "SelectPlatform",
  props: ['value', 'size'],
  data() {
    return {
      v: null,
      options: [],
    }
  },
  watch: {
    v(_) {
      this.$emit('update:value', _)
      this.$nextTick(() => {
        this.$emit('change')
      })
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      this.options = []
      const response = await getOptionListByField({field: 'platforms'})
      let platforms = response.model.list
      if (platforms) {
        platforms.forEach((item) => {
          this.options.push({label: item.label, value: item.label})
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
